import * as PropTypes from 'prop-types';
import * as React from 'react';
import PriceWithChange from './price_with_change';

class PromoProduct extends React.Component {
  static propTypes = {
    listing: PropTypes.object.isRequired,
    originalPrice: PropTypes.object.isRequired,
    bundledPrice: PropTypes.object,
  };

  render() {
    const listing = this.props.listing;

    return (
      <a href={listing._links.web.href}>
        <div className="g-container mb-half">
          <div className="g-col-3 g-col-mobile-2">
            <img className="img-wide bd-rounded img-hoverable bd-1 bd--offwhite" src={listing._links.photo.href} />
          </div>
          <div className="g-col-9 g-col-mobile-10">
            <p className="product-bundle-item-title strong color-gray">{listing.title}</p>
            <p className="product-bundle-item-price color-gray">
              <PriceWithChange price={this.props.originalPrice} bundledPrice={this.props.bundledPrice} />
            </p>
          </div>
        </div>
      </a>
    );
  }
}

export default PromoProduct;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/promo_product.jsx